import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLandingPagesAppGroupIdDuplicateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_pages_data",
];
